<div *ngIf="values && values.length" class="container mt-5 mb-5">
  <div class="text-center mb-4">
    <h3>{{ title }}</h3>
  </div>
  <div class="gcc-slider-produto">
    <div *ngFor="let p of values" class="imgslider">
      <a (click)="redirectTo.emit(p.id)">
        <div class="imgProduto">
          <div *ngIf="p.imagem; else elseBlockImg">
            <img
              src="{{ API_IMAGENS_PRODUTOS }}{{ p.imagem }}"
              class="img-fluid"
            />
          </div>
          <ng-template #elseBlockImg>
            <div>
              <img src="assets/no-product-image.jpg" class="img-fluid" />
            </div>
          </ng-template>
        </div>
      </a>
      <div class="mt-1 descr">{{ p.descricao }}</div>
      <div class="ref"><span class="ref-label">Ref.:</span> {{ p.referencia }}</div>
      <div *ngIf="mostraPreco">
        <div *ngIf="p.precoPromocional; else elseBlockPreco">
          <span class="moneyOff" i18n>R${{ p.preco | currency : "BRL" : "" }}</span>
          <span class="money1 ml-1" i18n
            >R${{ p.precoPromocional | currency : "BRL" : "" }}</span
          >
        </div>
        <ng-template #elseBlockPreco>
          <div *ngIf="p.preco">
            <span class="money" i18n>R${{ p.preco | currency : "BRL" : "" }}</span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
